module.exports = __webpack_public_path__ + "static/img/phone-icon4.18d00bdd.png";